export class DigitalMarketing {
  public digitalMarketingCarouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Web Design',
      categories: [],
      active: true
    }, {
      title: 'Web Development',
      categories: [],
    }, {
      title: 'Email Campaigns',
      categories: []
    }, {
      title: 'Content Marketing',
      categories: []
    }, {
      title: 'Digital Advertising',
      categories: []
    }, {
      title: 'Search engine optimization',
      categories: []
    }, {
      title: 'Analytics and campaign reporting',
      categories: []
    }
  ];
}